// styles
import { LoadingContainer } from "../styles";

interface AutoLoginLoaderProps {
  title: string;
  subtitle: string;
}

export const AutoLoginLoader = ({ title, subtitle }: AutoLoginLoaderProps) => {
  return (
    <LoadingContainer>
      <div
        className="spinner-border text-primary"
        style={{ width: "3rem", height: "3rem" }}
        role="status"
      />
      <div>
        <div className="loading-title">{title}</div>
        <div className="loading-subtitle">{subtitle}</div>
      </div>
    </LoadingContainer>
  );
};
